export function isNullOrUndefined(obj: unknown): obj is null | undefined {
  return obj === null || obj === undefined;
}

export function isNullOrEmptyString(obj: string): boolean {
  return !obj || !obj.length;
}

export function startsWithString(s: string, prefix: string): boolean {
  if (!prefix.length) {
    return true;
  }
  if (prefix.length > s.length) {
    return false;
  }
  return s.substr(0, prefix.length) === prefix;
}

export function endsWithString(s: string, suffix: string): boolean {
  if (!suffix.length) {
    return true;
  }
  if (suffix.length > s.length) {
    return false;
  }
  return s.substr(s.length - suffix.length) === suffix;
}

export function isValue(obj: unknown): boolean {
  return obj !== null && obj !== undefined;
}
